export default __webpack_public_path__ + "static/media/adr_courriel.a9bff3a8.png";